import React, {ComponentType, memo, PromiseLikeOfReactNode, Suspense} from "react";
import {
    Routes,
    Route,
    useNavigate,
    useLocation,
    Location, matchRoutes, useSearchParams
} from "react-router-dom";
import {Layout} from "../layouts/Layout";
import {EmptyLayout} from "../layouts/EmptyLayout";
import {useContext, useEffect} from "react";
import {RouteContext} from "./RouteContext";
import {Loader} from "../components/Loader/Loader";
import {Stack} from "@mui/material";
import {TFunction} from "i18next";
import {ApolloClient, NormalizedCacheObject, useMutation, useQuery} from "@apollo/client";
import {GET_USER} from "../store/queries/GetUser";
import languageList from "../utils/languageList";
import {RouteMatch, RouteObject} from "react-router";
import {useTranslation} from "react-i18next";

import {CHANGE_LANGUAGE_MUTATION} from "../store/mutations/ChangeLanguage";
import {GetUserQuery, User} from "../gql/graphql";
import Head from "next/head";
import dynamic from "next/dynamic";
import {notFound} from "next/navigation";
import NotFound from "next/dist/client/components/not-found-error";
import {GetServerSidePropsContext} from "next";
import {match} from "assert";

const ModalLayout = dynamic(() => import("../layouts/ModalLayout"), {
    loading: () => <ModalLoader/>
});
const ModalDialogLayout = dynamic(() => import("../layouts/ModalDialogLayout"), {
    loading: () => <ModalLoader/>
});
const UserModalLayout = dynamic(() => import("../layouts/UserModalLayout"), {
    loading: () => <ModalLoader/>
});


const BetsoftPromoTournament = dynamic(() => import("../views/offers/BetsoftPromoTournament"), {
    loading: () => <PageLoader/>
});
const PageWithBanner = dynamic(() => import("../views/home/PageWithBanner"), {
    loading: () => <PageLoader/>
});
const GameCategory = dynamic(() => import("../views/home/GameCategory"), {
    loading: () => <PageLoader/>
});
const Home = dynamic(() => import("../views/home/Home"), {
    loading: () => <PageLoader/>
});


const PageLoader = () => <Stack alignItems="center" justifyContent="center" sx={{
    height: "100vh",
    width: '100vw',
    background: (theme) => theme.palette.background.default,
    position: 'fixed',
    top: 0,
    bottom: 0,
    zIndex: 1600 //max MUI zIndex is 1500)
}}>
    <Loader disableShrink size={80}/></Stack>;
const ModalLoader = () => <Stack alignItems="center" justifyContent="center" sx={{
    height: "100%",
    width: '100%',
    top: 0,
    bottom: 0,
    zIndex: 1600 //max MUI zIndex is 1500)
}}>
    <Loader disableShrink size={80}/>
</Stack>;

//import LoginWithItsme from "../views/loginwithitsme/LoginWithItsme";
const LoginWithItsme = dynamic(() => import("../views/loginwithitsme/LoginWithItsme"), {
    loading: () => <ModalLoader/>
});
//import CompleteRegistration from "../views/completeregistration/CompleteRegistration";
const CompleteRegistration = dynamic(() => import("../views/completeregistration/CompleteRegistration"), {
    loading: () => <ModalLoader/>
});
const RequestRegistration = dynamic(() => import("../views/completeregistration/RequestRegistration"), {
    loading: () => <ModalLoader/>
});
//import {Error404} from "../views/errors/404";
const Error404 = dynamic(() => import("../views/errors/404"), {
    loading: () => <PageLoader/>
});
//import {Deposit} from "../views/user/transactions/deposit/Deposit";
const Deposit = dynamic(() => import("../views/user/transactions/deposit/Deposit"), {
    loading: () => <ModalLoader/>
});
//import {Tournaments} from "../views/tournaments/Tournaments";
const Tournaments = dynamic(() => import("../views/tournaments/Tournaments"), {
    loading: () => <PageLoader/>
});

//import {Offers} from "../views/offers/Offers";
const Offers = dynamic(() => import("../views/offers/Offers"), {
    loading: () => <PageLoader/>
});
//import {Game} from "../views/games/Games";
const Game = dynamic(() => import("../views/games/Games"), {
    loading: () => <PageLoader/>
});
//import {TournamentParticipation} from "../views/tournaments/TournamentParticipation";
const TournamentParticipation = dynamic(() => import("../views/tournaments/TournamentParticipation"));
//import {GamesExit} from "../views/games/GamesExit";
const GamesExit = dynamic(() => import("../views/games/GamesExit"), {
    loading: () => <PageLoader/>
});
//import {Withdraw} from "../views/user/transactions/withdraw/Withdraw";
const Withdraw = dynamic(() => import("../views/user/transactions/withdraw/Withdraw"), {
    loading: () => <ModalLoader/>
});
//import {History} from "../views/user/transactions/history/History";
const History = dynamic(() => import("../views/user/transactions/history/History"), {
    loading: () => <ModalLoader/>
});
//import {Details} from "../views/user/account/details/Details";
const Details = dynamic(() => import("../views/user/account/details/Details"), {
    loading: () => <ModalLoader/>
});
//import {Documents} from "../views/user/account/documents/Documents";
const Documents = dynamic(() => import("../views/user/account/documents/Documents"), {
    loading: () => <ModalLoader/>
});
//import {GameHistory} from "../views/user/account/gamehistory/GameHistory";
const GameHistory = dynamic(() => import("../views/user/account/gamehistory/GameHistory"), {
    loading: () => <ModalLoader/>
});
//import {Limits} from "../views/user/responsiblegaming/limits/Limits";
const Limits = dynamic(() => import("../views/user/responsiblegaming/limits/Limits"), {
    loading: () => <ModalLoader/>
});
//import {SelfExclusion} from "../views/user/responsiblegaming/selfexclusion/SelfExclusion";
const SelfExclusion = dynamic(() => import("../views/user/responsiblegaming/selfexclusion/SelfExclusion"), {
    loading: () => <ModalLoader/>
});
//import {ChangeLimit} from "../views/user/responsiblegaming/limits/ChangeLimit";
const ChangeLimit = dynamic(() => import("../views/user/responsiblegaming/limits/ChangeLimit"), {
    loading: () => <ModalLoader/>
});
//import {CancelDeposit} from "../views/user/transactions/deposit/CancelDeposit";
const CancelDeposit = dynamic(() => import("../views/user/transactions/deposit/CancelDeposit"), {
    loading: () => <ModalLoader/>
});
//import {DeclineDeposit} from "../views/user/transactions/deposit/DeclineDeposit";
const DeclineDeposit = dynamic(() => import("../views/user/transactions/deposit/DeclineDeposit"), {
    loading: () => <ModalLoader/>
});
//import {CompleteDeposit} from "../views/user/transactions/deposit/CompleteDeposit";
const CompleteDeposit = dynamic(() => import("../views/user/transactions/deposit/CompleteDeposit"), {
    loading: () => <ModalLoader/>
});
//import {ErrorDeposit} from "../views/user/transactions/deposit/ErrorDeposit";
const ErrorDeposit = dynamic(() => import("../views/user/transactions/deposit/ErrorDeposit"), {
    loading: () => <ModalLoader/>
});
//import {PrivacyPolicy} from "../views/privacypolicy/PrivacyPolicy";
const PrivacyPolicy = dynamic(() => import("../views/privacypolicy/PrivacyPolicy"), {
    loading: () => <PageLoader/>
});
//import {TermsAndConditions} from "../views/termsandconditions/TermsAndConditions";
const TermsAndConditions = dynamic(() => import("../views/termsandconditions/TermsAndConditions"), {
    loading: () => <PageLoader/>
});
//import {ForgotPassword} from "../views/forgotpassword/ForgotPassword";
const ForgotPassword = dynamic(() => import("../views/forgotpassword/ForgotPassword"), {
    loading: () => <ModalLoader/>
});
//import {ResetPassword} from "../views/forgotpassword/ResetPassword";
const ResetPassword = dynamic(() => import("../views/forgotpassword/ResetPassword"), {
    loading: () => <ModalLoader/>
});
//import {ConfirmEmail} from "../views/confirmemail/ConfirmEmail";
const ConfirmEmail = dynamic(() => import("../views/confirmemail/ConfirmEmail"), {
    loading: () => <ModalLoader/>
});
//import {TournamentHistory} from "../views/user/account/tournamenthistory/TournamentHistory";
const TournamentHistory = dynamic(() => import("../views/user/account/tournamenthistory/TournamentHistory"), {
    loading: () => <ModalLoader/>
});
//import {Login} from "../views/login/Login";
const Login = dynamic(() => import("../views/login/Login"), {
    loading: () => <ModalLoader/>
});
//import {Registration} from "../views/registration/Registration";
const Registration = dynamic(() => import("../views/registration/Registration"), {
    loading: () => <ModalLoader/>
});
const ResponsibleGaming = dynamic(() => import("../views/responsiblegaming/ResponsibleGaming"), {
    loading: () => <PageLoader/>
});
const SpinomenalPromo = dynamic(() => import("../views/offers/SpinomenalPromo"), {
    loading: () => <PageLoader/>
});
const TakeThePrizePromo = dynamic(() => import("../views/offers/TakeThePrizePromo"), {
    loading: () => <PageLoader/>
});
const RecentWins = dynamic(() => import("../views/wins/RecentWins"), {
    loading: () => <PageLoader/>
});
const PeppermillBoost = dynamic(() => import("../views/offers/PeppermillBoost"), {
    loading: () => <PageLoader/>
});
const InstantCashPromo = dynamic(() => import("../views/offers/InstantCashPromo"), {
    loading: () => <PageLoader/>
});
const BetsoftPromoCountdownToCashTournament = dynamic(() => import("../views/offers/BetsoftPromoCountdownToCashTournament"), {
    loading: () => <PageLoader/>
});
const BetsoftPromoCountdownToCashCashDrops = dynamic(() => import("../views/offers/BetsoftPromoCountdownToCashCashDrops"), {
    loading: () => <PageLoader/>
});
const Blog = dynamic(() => import("../views/blog/Blog"), {
    loading: () => <PageLoader/>
});
const BlogPost = dynamic(() => import("../views/blog/BlogPost"), {
    loading: () => <PageLoader/>
});

const staticLobbyRoute = {
    path: "/",
    element: <PageWithBanner/>,
    children: [
        {
            path: "/",
            element: <Home/>,
        }]
};
const gameCategoryRoutes = [
    {
        path: "/games", element: <PageWithBanner/>, children: [
            {
                path: "/games/dicegames",
                element: <GameCategory category={'dicegames'}/>,
            },
            {
                path: "/games/diceslots",
                element: <GameCategory category={'diceslots'}/>,
            },
            {
                path: "/games/tablegames",
                element: <GameCategory category={'tablegames'}/>,
            },
            {
                path: "/games/roulette",
                element: <GameCategory category={'roulette'}/>,
            },
            {
                path: "/games/baccarat",
                element: <GameCategory category={'baccarat'}/>,
            },
            {
                path: "/games/cardgames",
                element: <GameCategory category={'cardgames'}/>,
            },
            {
                path: "/games/videopoker",
                element: <GameCategory category={'videopoker'}/>,
            },
            {
                path: "/games/livecasino",
                element: <GameCategory category={'livecasino'}/>,
            },
            {
                path: "/games/virtualcasino",
                element: <GameCategory category={'virtualcasino'}/>,
            },
            {
                path: "/games/blackjack",
                element: <GameCategory category={'blackjack'}/>,
            },
            {
                path: "/games/all",
                element: <GameCategory category={'all'}/>,
            },
            {
                path: "/games/favorites",
                element: <GameCategory category={'favorites'}/>,
            },
            // {
            //     path: "/games/:provider",
            //     element: <PageWithBanner><GameCategory category={'all'}/></PageWithBanner>,
            // }
        ]
    }];
const lobbyRoutes = [

    staticLobbyRoute,
    ...gameCategoryRoutes
];


const inGameRoutes = [
    {
        element: <Layout forGame={true}/>,
        children: [
            {
                path: "/games/:gamestudio/:urlname", element: <Game/>
            }
        ],
    }
];

const cmsRoutes = [
    {
        path: "/blog/:slug", element: <BlogPost/>
    }];

const staticPageRoutes = [
    {
        path: "/tournaments", element: <Tournaments/>
    },
    {
        path: "/privacy", element: <PrivacyPolicy/>
    },
    {
        path: "/termsandconditions", element: <TermsAndConditions/>
    },
    {
        path: "/responsiblegaming", element: <ResponsibleGaming/>
    },
    {
        path: "/promotions", element: <Offers/>
    },
    {
        path: "/promotions/peppermill-boost", element: <PeppermillBoost/>
    },
    {
        path: "/promotions/instant-cash", element: <InstantCashPromo/>
    },
    {
        path: "/promotions/betsoft-countdown-to-cash/tournament", element: <BetsoftPromoCountdownToCashTournament/>
    },
    {
        path: "/promotions/betsoft-countdown-to-cash/cash-drops", element: <BetsoftPromoCountdownToCashCashDrops/>
    },
    {
        path: "/blog", element: <Blog/>
    }]
const pageRoutes = [
    {
        element: <Layout forGame={false}/>,
        children: [
            ...lobbyRoutes,
            ...staticPageRoutes,
            ...cmsRoutes,
            {
                path: "/wins/:category", element: <RecentWins/>
            },
            {
                path: "/exitGame", element: <GamesExit/>
            }
        ],
    }

];


const authPageRoutes = [
    {
        element: <Layout forGame={true}/>,
        children: [
            {
                path: "/tournament/:participationToken", element: <TournamentParticipation/>
            }
        ],

    }
];
const registerRoute = {
    path: "/register",
    element: <Registration/>,
};
const loginRoutes = [{
    path: "/login",
    element: <Login/>,
},
    {
        path: "/forgot-password",
        element: <ForgotPassword/>,
    },
    {
        path: "/reset-password",
        element: <ResetPassword/>,
    }];
const modalRoutes = [
    {
        element: <ModalLayout/>,
        children: [
            registerRoute,
            {
                path: "/complete-registration",
                element: <CompleteRegistration/>,
            }
        ],
    },
    {
        element: <ModalDialogLayout/>,
        children: [
            ...loginRoutes,
            {
                path: "/confirm-email",
                element: <ConfirmEmail/>,
            },
            {
                path: "/request-registration",
                element: <RequestRegistration/>,
            }
        ],
    },
    {
        element: <EmptyLayout/>,
        children: [

            {
                path: "/login-with-itsme",
                element: <LoginWithItsme/>,
            }
        ],
    }
];

const authModalRoutes = [
    {
        element: <UserModalLayout/>,
        children: [
            {
                path: "/withdraw",
                element: <Withdraw/>,
            },
            {
                path: "/transactions-history",
                element: <History/>,
            },
            {
                path: "/details",
                element: <Details/>,
            },
            {
                path: "/documents",
                element: <Documents/>,
            },
            {
                path: "/game-history",
                element: <GameHistory/>,
            },
            {
                path: "/tournament-history",
                element: <TournamentHistory/>,
            },
            {
                path: "/limits",
                element: <Limits/>,
            },
            {
                path: "/limits/change",
                element: <ChangeLimit/>,
            },
            {
                path: "/self-exclusion",
                element: <SelfExclusion/>,
            },
            {
                path: "/self-exclusion/confirm/:days",
                element: <SelfExclusion/>,
            }
        ],
    },
    {
        element: <ModalDialogLayout width={584}/>,
        children: [
            {
                path: "/deposit",
                element: <Deposit/>,
            },
            {
                path: "/deposit/decline",
                element: <DeclineDeposit/>,
            },
            {
                path: "/deposit/complete",
                element: <CompleteDeposit/>,
            },
            {
                path: "/deposit/cancel",
                element: <CancelDeposit/>,
            },
            {
                path: "/deposit/error",
                element: <ErrorDeposit/>,
            }
        ],
    }
];

export const siteMapRoutes = [
    staticLobbyRoute,
    ...gameCategoryRoutes[0].children,
    ...staticPageRoutes,
    registerRoute,
    ...loginRoutes
];

export type RouteWithServerSideData = ComponentType<{}> & {
    ServerSideData?: (client: ApolloClient<NormalizedCacheObject>, context: GetServerSidePropsContext, props?: any) => Promise<Array<Promise<any>> | null>
};
export const getServerSideDataForRoute = async (client: ApolloClient<NormalizedCacheObject>, context: GetServerSidePropsContext, t: TFunction) => {
    let matches = matchLocalizedRoutes([...pageRoutes, ...inGameRoutes, ...authPageRoutes, ...modalRoutes, ...authModalRoutes], `/${context.locale}${context.req.url}`, t);

    if (matchLocalizedRoutes([...modalRoutes, ...authModalRoutes], `/${context.locale}${context.req.url}`, t)) {
        if (matches == null)
            matches = matchLocalizedRoutes([...pageRoutes], `/${context.locale}`, t);
        else
            matches.push(...matchLocalizedRoutes([...pageRoutes], `/${context.locale}`, t) as RouteMatch<string, RouteObject>[]);
    }
    let toReturnPromises = new Array<Promise<any>>();
    if (matches)
        for (let i = 0; i < matches.length; i++) {

            let preload = (matches[i].route.element as any)?.type?.render?.preload;
            if (preload) {
                let promisesRorRoute = await (await preload()).default?.ServerSideData?.(client, context, (matches[i].route.element as any)?.props);
                if (promisesRorRoute)
                    toReturnPromises.push(...promisesRorRoute);
            }

        }
    ;
    return toReturnPromises;

}
export const matchLocalizedRoutes = (routes: RouteObject[], locationArg: Partial<Location> | string, t: TFunction): RouteMatch[] | null => {
    let location: Partial<Location> | string = locationArg;
    if (isLocalizedRoute(locationArg)) {
        location = typeof (locationArg) === "string" ? locationArg.slice(3) : locationArg.pathname?.slice(3) as string;
        return matchRoutes(routes.map(r => {
            return {
                ...r,
                path: r.path ? translateRouteValue2(r.path as string, t) : undefined,
                children: r.children?.map(sr => {
                    return {
                        ...sr, path: translateRouteValue2(sr.path as string, t),
                        children: sr.children?.map(ssr => {
                            return {
                                ...ssr, path: translateRouteValue2(ssr.path as string, t)
                            }
                        })
                    }
                })
            } as RouteObject
        }), location);
    }
    return matchRoutes(routes, location);

}


export const translateRoute = (to: string, language: string, t: TFunction) => {
    if (isLocalizedRoute(to)) {
        if (to.slice(3) == '/')
            return '/' + language;
        return to;
    }
    if (to == '/')
        return '/' + language;
    return '/' + language + translateRouteValue(to, language, t);
}
export const translateRouteValue = (to: string, language: string, t: TFunction) => {
    return to.split('/').map(
        value => {
            return value == "" ? "" : t('/' + value, {defaultValue: '/' + value, lng: language})
        }).toString().replaceAll(',', '');
}
export const translateRouteValue2 = (to: string, t: TFunction) => {

    let toReturn = to.split('/').map(
        value =>
            value == "" ? "" : t('/' + value, {defaultValue: '/' + value})).toString().replaceAll(',/', '/');
    if (toReturn == ",")
        toReturn = "/";
    return toReturn;
}

export const isLocalizedRoute = (locationArg: Partial<Location> | string) => {
    return !(languageList.find((x) => x.code == (typeof (locationArg) === "string" ? locationArg.substring(1, 3) : locationArg.pathname?.substring(1, 3))) === undefined);
}

export const getTranslationOfCurrentLocation = (location: Location, lng: string, t: TFunction) => {
    if (isLocalizedRoute(location.pathname)) {
        let translatedPath = translateRouteValue(location.pathname.slice(3), 'en', t);
        return translateRoute(translatedPath, lng, t) + location.search;
    }
    return translateRoute(translateRouteValue(location.pathname, 'en', t), lng, t) + location.search;
}

export const removeTrailingSlash = (url: string) => {
    if (url.endsWith('/'))
        return url.substring(0, url.length - 1);
    return url;
}

const RoutesWithLocationContext = ({location, noRoutesMatch}: { location: Location, noRoutesMatch: boolean }) => {
    const {t} = useTranslation();
    return (<>
            <div>

                <Routes location={location}>

                    {([...authPageRoutes, ...pageRoutes, ...inGameRoutes] as unknown as {
                        element: JSX.Element,
                        children: ({ path: string, element: JSX.Element, children?: undefined } | {
                            path: string,
                            element: JSX.Element,
                            children: { path: string, element: JSX.Element }[]
                        })[]
                    }[]).map((route, key) =>
                        <React.Fragment key={'pr' + key}>
                            <Route key={'p' + key} element={route.element}>
                                {route.children.map((child, key2) =>
                                    <Route key={'p' + key + '-' + key2} path={child.path}
                                           element={<Suspense
                                               fallback={<Stack alignItems="center" justifyContent="center" sx={{
                                                   height: "100vh",
                                                   width: '100vw',
                                                   background: (theme) => theme.palette.background.default,
                                                   position: 'fixed',
                                                   top: 0,
                                                   bottom: 0,
                                                   zIndex: 1600 //max MUI zIndex is 1500)
                                               }}>
                                                   <Loader disableShrink
                                                           size={80}/></Stack>}>{child.element}</Suspense>}>
                                        {child.children && child.children.map((subchild, key3) =>
                                            <Route key={'p' + key + '-' + key2 + '-' + key3} path={subchild.path}
                                                   element={<Suspense
                                                       fallback={<Stack alignItems="center" justifyContent="center"
                                                                        sx={{
                                                                            height: "100vh",
                                                                            width: '100vw',
                                                                            background: (theme) => theme.palette.background.default,
                                                                            position: 'fixed',
                                                                            top: 0,
                                                                            bottom: 0,
                                                                            zIndex: 1600 //max MUI zIndex is 1500)
                                                                        }}>
                                                           <Loader disableShrink
                                                                   size={80}/></Stack>}>{subchild.element}</Suspense>}/>)}
                                    </Route>
                                )}

                            </Route>
                            {languageList.map((language, key2) => {
                                return (
                                    <Route key={'pl' + key + '-' + key2} element={route.element}>
                                        {route.children.map((child, key3) =>
                                            <Route key={'pl' + key + '-' + key2 + '-' + key3}
                                                   path={'/' + language.code + translateRouteValue(child.path, language.code, t)}
                                                   element={<Suspense
                                                       fallback={<Stack alignItems="center" justifyContent="center"
                                                                        sx={{
                                                                            height: "100vh",
                                                                            width: '100vw',
                                                                            background: (theme) => theme.palette.background.default,
                                                                            position: 'fixed',
                                                                            top: 0,
                                                                            bottom: 0,
                                                                            zIndex: 1600 //max MUI zIndex is 1500)
                                                                        }}>
                                                           <Loader disableShrink
                                                                   size={80}/></Stack>}>{child.element}</Suspense>}>

                                                {child.children && child.children.map((subchild, key4) =>
                                                    <Route key={'pl' + key + '-' + key2 + '-' + key3 + '-' + key4}
                                                           path={'/' + language.code + translateRouteValue(subchild.path, language.code, t)}
                                                           element={<Suspense
                                                               fallback={<Stack alignItems="center"
                                                                                justifyContent="center" sx={{
                                                                   height: "100vh",
                                                                   width: '100vw',
                                                                   background: (theme) => theme.palette.background.default,
                                                                   position: 'fixed',
                                                                   top: 0,
                                                                   bottom: 0,
                                                                   zIndex: 1600 //max MUI zIndex is 1500)
                                                               }}>
                                                                   <Loader disableShrink
                                                                           size={80}/></Stack>}>{subchild.element}</Suspense>}/>)}
                                            </Route>)}
                                    </Route>
                                )
                            })}
                        </React.Fragment>
                    )}
                </Routes>
                <Routes>

                    {[...modalRoutes, ...authModalRoutes].map((route, key) =>
                        <React.Fragment key={'mr' + key}>
                            <Route key={'m' + key} element={route.element}>
                                {route.children.map((child, key2) =>
                                    <Route key={'m' + key + '-' + key2} path={child.path}
                                           element={child.element}/>)}
                            </Route>
                            {languageList.map((language, key2) => {
                                return (<Route key={'ml' + key + '-' + key2} element={route.element}>
                                        {route.children.map((child, key3) =>
                                            <Route key={'ml' + key + '-' + key2 + '-' + key3}
                                                   path={'/' + language.code + translateRouteValue(child.path, language.code, t)}
                                                   element={child.element}/>)}
                                    </Route>
                                )
                            })}
                        </React.Fragment>
                    )}
                </Routes>

                {noRoutesMatch && (
                    <Routes>
                        <Route element={<Layout forGame={false}/>}>
                            <Route path='/*' element={<Error404/>}/>
                        </Route>
                    </Routes>
                )}
            </div>
        </>
    );
};
const RoutesWithLocationContextMemo = memo(RoutesWithLocationContext, (prevProps, nextProps) => prevProps.location.search == nextProps.location.search && prevProps.location.pathname == nextProps.location.pathname && prevProps.noRoutesMatch == nextProps.noRoutesMatch);

const AppRoutes = () => {
    let location = useLocation();
    const routeState = useContext(RouteContext);
    const [noRoutesMatch, setNoRoutesMatch] = React.useState(false);
    const isAuthenticated = routeState.authenticated;
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const {loading, error, data} = useQuery<GetUserQuery>(GET_USER);
    const [widgetLanguage, SetWidgetLanguage] = React.useState(i18n.language);
    const [commit, _] = useMutation(CHANGE_LANGUAGE_MUTATION);
    const isBlogRoute = matchLocalizedRoutes([{path: '/blog/:slug'}], location, t);
    const changeLanguage = (language: string) => {
        i18n.changeLanguage(language);

        if (isAuthenticated) {
            // Save language choice in database
            commit({
                variables: {
                    value: language
                }
            });
        }
        const htmlEl = document.getElementsByTagName('html');
        if (htmlEl && htmlEl.length > 0) {
            htmlEl[0].setAttribute('lang', i18n.language);
        }
        document.cookie = `locale=${language}; path=/; max-age=31536000`;
    }


    useEffect(() => {
        if (!isLocalizedRoute(location.pathname)) {
            navigate(translateRoute(translateRouteValue(location.pathname, 'en', t), i18n.language, t) + location.search);
        }
        if (isLocalizedRoute(location.pathname) && location.pathname.substring(1, 3) != i18n.language) {
            changeLanguage(location.pathname.substring(1, 3));
            navigate(translateRoute(translateRouteValue(location.pathname.slice(3), 'en', t), location.pathname.substring(1, 3), t) + location.search);
        }
        if (isLocalizedRoute(location.pathname) && getTranslationOfCurrentLocation(location, location.pathname.substring(1, 3), t) != location.pathname + location.search)
            navigate(getTranslationOfCurrentLocation(location, location.pathname.substring(1, 3), t));
    }, [location]);
    useEffect(() => {
        if (!isLocalizedRoute(location.pathname)) {
            navigate(translateRoute(translateRouteValue(location.pathname, 'en', t), i18n.language, t) + location.search);
        }
        if (isLocalizedRoute(location.pathname) && location.pathname.substring(1, 3) != i18n.language) {
            navigate(translateRoute(translateRouteValue(location.pathname.slice(3), 'en', t), i18n.language, t) + location.search);
        }
    }, [i18n.language]);
  
    useEffect(() => {
        if (location.search.toLowerCase().indexOf('btag') > -1) {
            var tag = new URLSearchParams(location.search.toLowerCase()).get('btag');
            const requestOptions: RequestInit = {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({btag: tag}),
                credentials: "include"
            };
            fetch(`${(process.env.NEXT_PUBLIC_API_URL as string).replace('graphql', 'Identity/IncomeAccess')}`, requestOptions);
        }
    }, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if (routeState.backgroundLocation == null && (matchLocalizedRoutes(pageRoutes, location, t) != null || (matchLocalizedRoutes(authPageRoutes, location, t) != null && isAuthenticated)) || (matchLocalizedRoutes(inGameRoutes, location, t) != null && (isAuthenticated || searchParams.get('mode') === 'demo'))) {
            let previousRouteIsLobbyRoute = matchLocalizedRoutes(lobbyRoutes, routeState.previousLocation, t) != null;
            let currentRouteIsLobbyRoute = matchLocalizedRoutes(lobbyRoutes, location, t) != null;
            if (!(previousRouteIsLobbyRoute && currentRouteIsLobbyRoute)) {
                window.scrollTo({left: 0, top: 0, behavior: "auto"});
            }
            routeState.setRouteState({
                ...routeState,
                previousLocation: location,
                currentRouteIsProtectedRoute: matchLocalizedRoutes(authPageRoutes, location, t) != null || (matchLocalizedRoutes(inGameRoutes, location, t) != null && searchParams.get('mode') === 'cash'),
                authenticated: isAuthenticated
            });
        }
        if (matchLocalizedRoutes(modalRoutes, location, t) != null || (matchLocalizedRoutes(authModalRoutes, location, t) != null)) {
            routeState.setRouteState({
                ...routeState,
                backgroundLocation: routeState.previousLocation,
                currentRouteIsProtectedRoute: matchLocalizedRoutes(authModalRoutes, location, t) != null,
                authenticated: isAuthenticated
            })
        }

        setNoRoutesMatch(matchLocalizedRoutes([...pageRoutes, ...inGameRoutes, ...authPageRoutes, ...modalRoutes, ...authModalRoutes], location, t) == null);
    }, [location]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        if ((matchLocalizedRoutes([...authPageRoutes, ...authModalRoutes], location, t) != null && isAuthenticated == false) || (matchLocalizedRoutes(inGameRoutes, location, t) != null && searchParams.get('mode') === 'cash' && !isAuthenticated)) {
            navigate(translateRoute("/login", i18n.language, t), {replace: true, state: {from: location}});
        }
    }, [location, isAuthenticated]);

    useEffect(() => {
        if ((data?.identity as User | null)?.language && (data?.identity as User | null)?.language?.toLowerCase() != i18n.language)
            changeLanguage((data?.identity as User | null)?.language?.toLowerCase() ?? i18n.language);
    }, [data]);

    return (<>

        <Head>
            <meta name={'sdkid'} content={(data?.identity as User | null)?.wallet.id ?? ''}/>
                {!isBlogRoute && languageList.map((lang, index) => {
                    return (
                        <link rel="alternate" key={lang.code} hrefLang={lang.code}
                              href={`${process.env.NEXT_PUBLIC_URL}${getTranslationOfCurrentLocation(location, lang.code, t)}`}/>
                    )
                })}
                {!isBlogRoute &&
                    <>
                        <link rel="alternate" hrefLang="x-default"
                              href={`${process.env.NEXT_PUBLIC_URL}${getTranslationOfCurrentLocation(location, 'en', t)}`}/>
                        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_URL}${location.pathname}`}/>
                    </>
                }
        </Head>

        <RoutesWithLocationContextMemo location={routeState.backgroundLocation || location}
                                       noRoutesMatch={noRoutesMatch}/></>);
}

export default AppRoutes;
export {
    pageRoutes,
    inGameRoutes,
    authPageRoutes,
    modalRoutes,
    authModalRoutes
};